import classNames from 'classnames'
import moment from 'jalali-moment'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
interface IItemProps {
    item: IMoneyPoolLoansResult
}
export default function Item({ item }: IItemProps) {
    const navigate = useNavigate()
    const { id } = useParams()
    return (
        <>
            <div
                className={classNames(
                    'rounded-md border border-main-bg px-2 mx-2 my-3 shadow-md',
                    item.is_fully_repaid && 'bg-gray-400'
                )}
                onClick={() =>
                    navigate(
                        `/fund/financial-history/funds-detail/${id}/${item.poolship_id}/${item.id}`,
                        { state: { name: item.poolship_name } }
                    )
                }
            >
                <div className="flex justify-center items-center">
                    {item.number_of_delayed_installments > 0 ? (
                        <p className="rounded-bottom bg-red-3 w-fit pr-2 pl-2 text-white">
                            {item.number_of_delayed_installments} قسط معوق
                        </p>
                    ) : null}
                </div>
                <div className="grid grid-cols-3 py-1 px-2 items-center">
                    <p className="col-span-1 items-center">
                        {item.poolship_name}
                    </p>
                    {item.is_fully_repaid ? (
                        <span className="col-span-1 bg-main-bg rounded-md px-1 text-sm text-center items-center py-2">
                            تسویه شده
                        </span>
                    ) : (
                        <div className="col-span-1 text-sm text-center">
                            <p className="col-span-1 text-sm text-center">
                                {item.number_of_repayments} قسط
                            </p>
                        </div>
                    )}
                    <div className="col-span-1 text-left">
                        <p className="text-sm">
                            {item.amount && item.amount.toLocaleString()} تومان
                        </p>
                        <p className="text-sm">
                            {item.pay_date &&
                                moment(item.pay_date, 'YYYY-MM-DD')
                                    .locale('fa')
                                    .format('YYYY-MM-DD')}
                        </p>
                    </div>
                </div>
                {item.tag && (
                    <>
                        <hr />
                        <p className=" text-sm py-1">توضیحات : {item.tag}</p>
                    </>
                )}
            </div>
        </>
    )
}
